import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from '../home/HomePage';
import ResultsPage from '../results/ResultsPage';

const App = () =>
  (
    <Routes>
      <Route exact path="/" element={<HomePage />} />
      <Route exact path="/results" element={<ResultsPage />} />
    </Routes>
  );

export default App;
